import getItemById from "../../../src/util/getItemById";
import GameState from "../../../src/enum/gamestate";
import { ApiGame } from "../../../src/types/apigame";
import GamesListCrown from "./crown";

type Props = {
    game: ApiGame;
    userId: number;
}

export default function GameGamesListJewel(
    {
        game,
        userId,
    }: Props,
) {
    const activeSeats = game.activeSeats;
    const mySeatObject = getItemById(activeSeats, userId, 'userId');

    let icon = null;
    if (
        game.state === GameState.Complete
        && mySeatObject
        && !game.subState?.wasCanceled
    ) {
        icon = <GamesListCrown />;
    }

    return icon;
}
